export enum FrameworkFilterOptions {
    All = "all-filter",
    Gated = "gated",
    NotGated = "not-gated",
    InPlayer = "in-player",
    NotInPlayer = "not-in-player",
    Shoppable = "shoppable",
    NotShoppable = "not-shoppable",
    Published = "published",
    Unpublished = "unpublished",
    Scheduled = "scheduled"
}

export enum CoreFilterOptions {
    All = "all-filter",
    Gated = "gated",
    NotGated = "not-gated",
    InPlayer = "in-player",
    NotInPlayer = "not-in-player",
    Shoppable = "shoppable",
    NotShoppable = "not-shoppable",
    Published = "published",
    Unpublished = "unpublished"
}

export enum SortOptions {
    NewestFirst = "newest-first",
    OldestFirst = "oldest-first",
    Next = "next",
    Last = "last",
    TitleAZ = "title-a-z",
    TitleZA = "title-z-a",
    MostViews = "most-views",
    LeastViews = "least-views"
}

export interface SearchSortBarProps {
    /** The user's selected sort option. */
    selectedSortOption?: string;
    /** Take user's input and set the selectedSortOption. */
    handleSortChange?: (option: SortOptions) => void;
    hiddenSortOptions?: SortOptions[];
    /** An array of options objects by which to categorize. */
    categoryOptions?: {
        value: string;
        text: string;
    }[];
    /** The user's selected category option. */
    selectedCategoryOption?: string;
    /** Take user's input and set the selectedCategoryOption. */
    handleCategoryChange?: (option: string) => void;
    /** The user's search query. */
    query?: string;
    /** Take user's input and set the query. */
    handleTextChange?: (text: string) => void;
    /** Whether to show the filter options. */
    showFilters?: boolean;
    setSelectedFilterOption?: (option: string) => void;
    selectedFilterOption?: string;
    useCoreFilterOptions?: boolean;
    onClear?: () => void;
}
